import type {
  Account,
  Entry as UserEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { DeepReadonlyObject } from "rxdb"
import { useFindUserEntries } from "./useFindUserEntries"
import { createEntryQueryObject } from "src/utils"

export function useOldestUserEntry(accountId: Account["id"]):
| DeepReadonlyObject<UserEntry>
| undefined {
  const queryObject = useMemo(
    () => createEntryQueryObject(
      accountId,
      {
        sort: [{ started_at: "asc" as const }],
        limit: 1,
      },
    ),
    [accountId],
  )

  const { result } = useFindUserEntries(queryObject)
  return result[0]
}
